/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForEngineTest extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForEngineTest");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForEngineTest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForEngineTest>): BackgroundJobPayloadForEngineTest {
        let obj = Object.assign(new BackgroundJobPayloadForEngineTest(), model);
        BackgroundJobPayloadForEngineTest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForEngineTest>): BackgroundJobPayloadForEngineTest {
        if (!model) return null;
        return BackgroundJobPayloadForEngineTest.newInstance(<BackgroundJobPayloadForEngineTest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForEngineTest) {
        if (!obj) return;

        models.BackgroundJobPayloadForEngineTest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForEngineTest): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForEngineTest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.sleep === undefined) {
            this.sleep = 0;
        }
        if (this.reschedule === undefined) {
            this.reschedule = 0;
        }
        if (this.sub_jobs) {
            for (let val of this.sub_jobs) {
                models.BackgroundJobEngineTestSub.fixupPrototype(val);
            }
        }
    }

    header: string;

    sleep: number;

    reschedule: number;

    cause_failure: string;

    honor_cancellation: boolean;

    sub_jobs: Array<models.BackgroundJobEngineTestSub>;

}
